import { useEffect, useState } from 'react';

export default function AdminGoogleCalendarConnect() {
  const [connected, setConnected] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setConnected(params.get('status') === 'connected');
  }, []);
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold">Google Calendar Connect (Admin)</h1>
      {connected ? (
        <p className="mt-4">✅ Google Calendar connected successfully</p>
      ) : (
        <a className="btn mt-4" href={`${process.env.NODE_ENV === 'production' ? 'https://api.myhomey.ai' : 'http://localhost:5001'}/v1/auth/google`}>
          Connect Google Calendar
        </a>
      )}
    </div>
  );
}


